<y42-dialog
  [dialogTitle]="'Image options'"
  [width]="'medium'"
  [height]="'huge'"
  class="image-crop-dialog"
  [confirmLabel]="'Save'"
  (confirm)="crop()"
>
  <div y42DialogBody class="flex flex-col md:flex-row h-full w-full gap-space-x3">
    <div class="flex grow flex-col">
      <div class="flex grow relative mb-space-x4">
        <image-cropper
          [imageChangedEvent]="data.imageChangedEvent"
          [maintainAspectRatio]="lockRatio"
          [containWithinAspectRatio]="containWithinAspectRatio"
          [aspectRatio]="ratio"
          [onlyScaleDown]="true"
          [roundCropper]="false"
          [canvasRotation]="canvasRotation"
          [transform]="transform"
          [alignImage]="'left'"
          [style.display]="showCropper ? null : 'none'"
          format="png"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded()"
          class="image-cropper"
        ></image-cropper>
      </div>
      <div class="image-crop-dialog-footer">
        <button
          [intercomTarget]="'image-crop-crop'"
          mat-flat-button
          mat-dialog-close
          [disabled]="!croppedImage"
          (click)="crop()"
        >
          <y42-icon [icon]="'crop-simple'"></y42-icon>
          <span>Crop</span>
        </button>
        <ng-container *ngIf="enableRotate">
          <button mat-flat-button [intercomTarget]="'image-crop-rotate-left'" (click)="rotateLeft()">
            <y42-icon [icon]="'undo'"></y42-icon>
            <span>Rotate left</span>
          </button>

          <button mat-flat-button [intercomTarget]="'image-crop-rotate-right'" (click)="rotateRight()">
            <y42-icon [icon]="'redo'"></y42-icon>
            <span>Rotate right</span>
          </button>
        </ng-container>

        <ng-container *ngIf="enableFlip">
          <button mat-flat-button [intercomTarget]="'image-crop-flip-vertical'" (click)="flipVertical()">
            <y42-icon [icon]="'arrows-alt-v'"></y42-icon>
            <span>Flip vertical</span>
          </button>

          <button mat-flat-button [intercomTarget]="'image-crop-flip-horizontal'" (click)="flipHorizontal()">
            <y42-icon [icon]="'arrows-alt-h'"></y42-icon>
            <span>Flip horizontal</span>
          </button>
        </ng-container>

        <button
          mat-flat-button
          *ngIf="enableContain"
          [intercomTarget]="'image-crop-toggle-contain-aspect-ratio'"
          (click)="toggleContainWithinAspectRatio()"
        >
          <y42-icon [icon]="containWithinAspectRatio ? 'expand-arrows-alt' : 'expand-wide'"></y42-icon>
          <span>Toggle contain</span>
        </button>

        <ng-container *ngIf="enableZoom">
          <button mat-flat-button [intercomTarget]="'image-crop-zoom-out'" (click)="zoomOut()">
            <y42-icon [icon]="'search-minus'"></y42-icon>
            <span>Zoom out</span>
          </button>

          <button mat-flat-button [intercomTarget]="'image-crop-zoom-in'" (click)="zoomIn()">
            <y42-icon [icon]="'search-plus'"></y42-icon>
            <span>Zoom in</span>
          </button>
        </ng-container>
      </div>
    </div>

    <div class="image-crop-dialog-panel">
      <p class="size-properties-block">
        Dimensions
        <span class="bg-background-secondary p-space-x2 rounded-standard"> h: {{ imgHeight }} </span>
        <y42-icon [icon]="'close'"></y42-icon>
        <span class="bg-background-secondary p-space-x2 rounded-standard"> w: {{ imgWidth }} </span>
      </p>

      <div *ngIf="enableRatio && ratioOptions.length">
        <h4 class="image-crop-dialog-subtitle">Aspect ratio</h4>
        <div class="flex items-start gap-space-x2">
          <div class="custom-mat-form-wrapper grow">
            <mat-form-field appearance="fill" SubscriptSizing="dynamic" class="w-full">
              <mat-select
                [(ngModel)]="ratio"
                (selectionChange)="changeRatio($event)"
                hideSingleSelectionIndicator
                panelClass="custom-mat-select-panel"
              >
                <mat-option *ngFor="let ratio of ratioOptions; trackBy: trackByValueProp" [value]="ratio.value">
                  {{ ratio.key }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <button
            *ngIf="enableRatio"
            mat-flat-button
            color="primary"
            [intercomTarget]="'image-crop-lock-ratio'"
            (click)="toggleLock()"
            class="image-crop-lock-button"
          >
            {{ lockRatio ? 'Unlock' : 'Lock' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</y42-dialog>
